import { MLStemSplitterPrimaryModelType, SplitInstrumentalMethod } from '../types'

export const getMLStemSplitterPrimaryModelType = ({
  deharmony,
  dereverb,
  denoise,
  debreath,
  splitInstrumental,
  split4Stems
}: {
  deharmony?: boolean
  dereverb?: boolean
  denoise?: boolean
  debreath?: boolean
  splitInstrumental?: boolean
  split4Stems?: boolean
}) => {
  if (split4Stems) {
    return MLStemSplitterPrimaryModelType.SPLIT_4_STEMS
  }
  if (splitInstrumental) {
    return MLStemSplitterPrimaryModelType.SPLIT_INSTRUMENTAL
  }
  if (deharmony) {
    return MLStemSplitterPrimaryModelType.DEHARMONY
  }
  if (dereverb) {
    return MLStemSplitterPrimaryModelType.DEREVERB
  }
  if (denoise) {
    return MLStemSplitterPrimaryModelType.DENOISE
  }
  if (debreath) {
    return MLStemSplitterPrimaryModelType.DEBREATH
  }
  return MLStemSplitterPrimaryModelType.SPLIT_INSTRUMENTAL
}

export const getMLStemSplitterSplitInstrumentalType = ({
  defaultSplitInstrumentalMethod,
  splitInstrumental,
  split2Stems,
  splitInstrumentalViperX
}: {
  defaultSplitInstrumentalMethod?: string
  splitInstrumental?: boolean
  split2Stems?: boolean
  splitInstrumentalViperX?: boolean
}): SplitInstrumentalMethod | undefined => {
  if (!splitInstrumental) return undefined
  if (split2Stems) return SplitInstrumentalMethod.DEMUCS_4
  if (splitInstrumentalViperX) return SplitInstrumentalMethod.BS_ROFORMER_VIPERX

  if (defaultSplitInstrumentalMethod)
    return defaultSplitInstrumentalMethod as SplitInstrumentalMethod
  return SplitInstrumentalMethod.VOC_FT
}
